// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper__N8+Pr","item":"Dropdown_item__3mvmZ","activeItem":"Dropdown_activeItem__Ny8R4","label":"Dropdown_label__kGXOg","icon":"Dropdown_icon__Jetfo"};